import { initAnalytics } from 'analytics';
import { QueryClient, QueryClientProvider } from 'api';
import { I18nWithUserLanguage, mergeI18nResources, platformI18nResources } from 'i18n';
import { initMonitoring } from 'monitor';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, ScrollRestoration } from 'react-router-dom';
import { dateAdapter, LocalizationProvider, ThemeProvider } from 'ui';

import { App } from './App';
import { internalI18nResources } from './i18n/resources';

const reactAppRoot = document.getElementById('react-app-id');

initAnalytics();
initMonitoring('internal');
const queryClient = new QueryClient();
const i18nResources = mergeI18nResources(platformI18nResources, internalI18nResources);

const AppProviders = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nWithUserLanguage resources={i18nResources}>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={dateAdapter} adapterLocale="en-gb">
            <App />
            <ScrollRestoration />
          </LocalizationProvider>
        </ThemeProvider>
      </I18nWithUserLanguage>
    </QueryClientProvider>
  );
};

const router = createBrowserRouter([
  {
    element: <AppProviders />,
    path: '*',
  },
]);

if (reactAppRoot) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  ReactDOM.createRoot(reactAppRoot!).render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}
